import { Link } from 'react-router-dom';
import { useT } from '../i18n/useLanguage';

export default function Footer() {
  const t = useT();
  // Layout per Figma 1:4383:
  //   • Black footer with rounded-top corners (50px radius in Figma).
  //   • A single white 8px top border that follows the rounded curve
  //     (Figma layers two black rectangles with the lower one masking
  //     the bottom of an `border-8` outline — same visual is achieved
  //     here with `border-t-8 rounded-t-[50px]`).
  //   • Three centred rows stacked vertically: legal nav (privacy +
  //     term of service), brand logos (gmillion + sonew), copyright.
  return (
    <footer className="rounded-t-[50px] border-t-8 border-white bg-footer-bg text-white">
      <div className="mx-auto flex max-w-screen-2xl flex-col items-center gap-3 px-4 py-5 text-center md:gap-6 md:px-8 md:py-12 lg:gap-4 lg:py-8">
        {/* Legal nav — "privacy policy" + "term of service". Figma
            renders these at 24px IBM Plex Sans Thai Bold; we use the
            font-thai stack at responsive sizes that scale down to
            mobile while hitting 24px at the lg breakpoint. */}
        <nav
          aria-label="Legal"
          className="flex items-center gap-8 font-thai text-base font-bold md:gap-12 md:text-lg lg:gap-[24px] lg:text-2xl"
        >
          <Link to="/privacy" className="transition hover:text-tan/80">
            {t('footer.privacy')}
          </Link>
          <Link to="/tos" className="transition hover:text-tan/80">
            {t('footer.terms')}
          </Link>
        </nav>

        {/* Brand logos row — gmillion + sonew side-by-side. The
            gap matches Figma's 30px on lg; the logos use h-[61px]
            (Figma) on lg with w-auto so the asset's natural aspect
            preserves at every size. */}
        <div className="flex items-center gap-6 md:gap-8 lg:gap-[30px]">
          <img
            src="/images/gmillion-logo.png"
            alt="GMillion"
            className="h-8 w-auto object-contain md:h-12 lg:h-[61px]"
            onError={(e) => (e.currentTarget.style.display = 'none')}
          />
          <img
            src="/images/sonew-logo.png"
            alt="SoNew"
            className="h-8 w-auto object-contain md:h-12 lg:h-[61px]"
            onError={(e) => (e.currentTarget.style.display = 'none')}
          />
        </div>

        {/* Support contact — mirrors the under-construction page so the
            App Store reviewer-facing support email is reachable from the
            full site too (Review Guideline 1.5 — Developer Information). */}
        <p className="font-thai text-xs md:text-sm">
          <span className="font-bold">{t('hero.supportLabel')}:</span>{' '}
          <a
            href="mailto:support@gmillion.io"
            className="underline underline-offset-2 transition hover:text-tan/80"
          >
            support@gmillion.io
          </a>
        </p>

        {/* Copyright line — Figma renders this at 20px IBM Plex Sans
            Thai Bold, so we scale from text-sm on mobile up to
            text-xl (20px) on lg. */}
        <p className="font-thai text-xs">
          {t('footer.copyright')}
        </p>
      </div>
    </footer>
  );
}
